// 后台主题（D200）：跟随系统、浅色、深色三选一，浏览器记住。手动选的主题写在 <html data-theme> 上，
// 跟随系统时去掉这个属性，由 tokens.css 的 prefers-color-scheme 决定。index.html 里有一段同样读这个键的内联脚本，
// 在首屏绘制前设好属性，避免手动选了深色、系统是浅色时先闪一下浅色；改键名要两边一起改。
import { useCallback, useState } from "react";
import { readPref, writePref } from "@/app/storage";

export type ThemePref = "system" | "light" | "dark";

export const THEME_KEY = "axon.theme";
const DARK_QUERY = "(prefers-color-scheme: dark)";

/** 读记住的主题偏好，没记过或不认识时跟随系统。 */
export function storedTheme(): ThemePref {
  const v = readPref(THEME_KEY);
  return v === "light" || v === "dark" ? v : "system";
}

/** 把偏好设到 <html data-theme> 上；跟随系统时去掉属性。 */
export function applyTheme(pref: ThemePref) {
  const root = document.documentElement;
  if (pref === "system") root.removeAttribute("data-theme");
  else root.setAttribute("data-theme", pref);
}

const systemDark = () => window.matchMedia?.(DARK_QUERY).matches ?? false;

/** 此刻实际生效的主题，给只渲染一次、不跟着重渲染的第三方组件用（例如 Turnstile）。 */
export function currentTheme(): "light" | "dark" {
  const pref = storedTheme();
  return pref === "system" ? (systemDark() ? "dark" : "light") : pref;
}

/** 当前主题偏好和修改它的方法；改了立即生效并记住。 */
export function useTheme() {
  const [pref, setPrefState] = useState(storedTheme);
  const setPref = useCallback((p: ThemePref) => {
    setPrefState(p);
    applyTheme(p);
    writePref(THEME_KEY, p);
  }, []);
  return { pref, setPref };
}
